import { Chip, ChipProps } from '@mui/material'

type TargetTypeChipsProps = {
  code?: number
  label?: string
} & ChipProps
export const TargetTypeChips = ({
  code,
  label,
  ...others
}: TargetTypeChipsProps) => {
  return (code && label && code !== 0) ? (
    <Chip
      {...others}
      variant={(code === 1 || code === 3) ? 'filled' : 'outlined'}
      color={
        (code === 1 || code === 2) ? 'primary' :
        (code === 3 || code === 4) ? 'secondary' : 'default'
      }
      label={label}
      size="small"
    />
  ) : (
    <></>
  )
}
